import React from 'react';
import Image from '../mepic.png'
const MeLogo = () => {
    return (
        <div className='flex justify-center items-center'>
            <img src={Image} style={{ width: "10.5rem", height: "7rem", }} />
        </div>
    )
}
export default MeLogo;